export default function getOrderSource (vm) {
  return vm?.$vuetify?.breakpoint?.mdAndDown ? 'mobile_web' : 'desktop_web'
}
